/*
 * @Description  : mutations
 * @usage        :
 * @FilePath: /app-monorepo-projects/packages/app-share/src/store/mutations.ts
 */
import { ModelCollectionInfo, ModelMetaFeed } from '@/types/model';
import { MutationTree } from 'vuex';
import MutationTypes from './mutation-types';
import { State } from './state';

const mutations: MutationTree<State> = {
  [MutationTypes.SET_IS_COLLECTION](state, { value }: { value: State['isCollection']}) {
    state.isCollection = !!value;
  },
  [MutationTypes.SET_IS_NEWUI](state, { value }: { value: State['isNewUI']}) {
    state.isNewUI = !!value;
  },
  [MutationTypes.SET_SHOW_COLLECTION](state, { value }: { value: State['showCollection']}) {
    state.showCollection = !!value;
  },
  [MutationTypes.SET_ACTIVE_PLAYER_PLAYING](state, { value }: { value: State['activePlayerPlaying']}) {
    state.activePlayerPlaying = !!value;
  },
  [MutationTypes.SET_COLLECTION_INFO](state, { value }: { value: State['collectionInfo']}) {
    state.collectionInfo = value;
  },
  [MutationTypes.SET_FEEDS_LIST](state, { value }: { value: State['feedsList']}) {
    state.feedsList = value;
  },
  [MutationTypes.SET_ACTIVE_INDEX](state, { value }: { value: State['activeIndex']}) {
    state.activeIndex = value;
  },
  [MutationTypes.SET_GROWTHTEST_DATA](state, { value }: { value: State['growthTestData']}) {
    state.growthTestData = value;
  },
  [MutationTypes.SET_SHARE_UI](state, { value }: { value: State['shareUi']}) {
    state.shareUi = value;
  },
  [MutationTypes.SET_BANNER](state, { value }: { value: State['banner']}) {
    state.banner = value;
  },
  [MutationTypes.SET_ERROR_MSG](state, { value }: { value: State['errorMsg']}) {
    state.errorMsg = value;
  },
  [MutationTypes.INITIALIZE_COLLECTION_DATA](
    state,
    { value }: { value: { feedList: ModelMetaFeed[], collection: ModelCollectionInfo,  feedId: string}
    },
  ) {
    state.feedsList = value.feedList; // 初始化视频列表数据
    state.isCollection = true;  // 设置页面属性为精选集
    state.collectionInfo = value.collection; // 初始化精选集详情数据
    state.activeIndex =  Math.max(value.feedList.findIndex(feed => feed.id === value.feedId), 0); // 初始化当前视频索引
  },
  [MutationTypes.SET_GROWTH_POPUP](state, value: State['isGrowthPopup']) {
    state.isGrowthPopup = value;
  },
};

export default mutations;
